import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { ENRICHMENT_STATE } from '@aibees/elephant/types';

export function checkRevelationEmailState(data?: PeopleTableInfo) {
  return (
    data?.revelation?.email?.state &&
    data?.revelation?.email?.state !== ENRICHMENT_STATE.PROCESSING
  );
}
